// @ts-expect-error not typed

// @ts-expect-error not typed yet

// @ts-expect-error not typed
import CloneOrConvertNotAllowedModal from 'EmailComponents/modals/details/CloneOrConvertNotAllowedModal';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import { EMAIL_CREATION_TYPES } from 'EmailData/constants/emailCreation';
import EMAIL_TEMPLATE_MODE from 'EmailData/enums/EmailTemplateModes';
import { getCanCloneToAutomated } from 'EmailData/utils/details/detailTypeUtil';
import { getIsAutomatedLike, getIsFollowupEmail } from 'EmailData/utils/emailStateUtil';
import I18n from 'I18n';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { MARKETING_EMAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import useGetCRMObjectByID from 'messaging-management-lib/crm/hooks/useGetCRMObjectByID';
import useGetAssignedCustomProperties from 'messaging-management-lib/customProperties/hooks/useGetAssignedCustomProperties';
import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
import useEmailCloneCustomPropertiesState from '../hooks/useEmailCloneCustomPropertiesState';
import ConvertToCloneModal from './ConvertToCloneModal';
import EmailCloneSidePanel from './EmailCloneSidePanel';
import { jsx as _jsx } from "react/jsx-runtime";
const CONTENT_NAME_MAX_LENGTH = 200;
const getExtraCloneOptions = (email, hasAutomatedAccess) => {
  if (!getCanCloneToAutomated(email, hasAutomatedAccess)) {
    return {
      subcategory: 'batch',
      state: 'DRAFT'
    };
  }
  return {};
};
function CloneOrConvertModal({
  canAccessBusinessUnit,
  crmObject,
  confirmClone,
  email,
  emailDetails,
  hasAutomatedAccess,
  hasCustomPlaintext,
  isCloneDataReady,
  isCloneDataErrored,
  isConvertible,
  onClose,
  smartContentLocations,
  userCanCreateClassicEmail,
  variantSmartContentLocations,
  variantHasCustomPlaintext
}) {
  var _ref;
  const {
    crmObject: loadedCRMObject,
    isLoadingCRMObject
  } = useGetCRMObjectByID({
    objectTypeId: MARKETING_EMAIL_TYPE_ID,
    id: email.crmObjectId,
    skip: !!crmObject
  });
  const {
    assignedCustomProperties,
    isLoadingAssignedCustomProperties
  } = useGetAssignedCustomProperties({
    objectTypeId: MARKETING_EMAIL_TYPE_ID,
    // @ts-expect-error workaround for crmObject possibly being undefined
    crmObject: (_ref = crmObject !== null && crmObject !== void 0 ? crmObject : loadedCRMObject) !== null && _ref !== void 0 ? _ref : {},
    requiredGates: ['CRM:Properties:Email']
  });
  const {
    shouldCloneCustomProperties
  } = useEmailCloneCustomPropertiesState();
  const suffix = I18n.text('email-management.emailClone.cloneSidePanel.clonedContentSuffix');
  const handleConvertAction = () => {
    trackDashboardInteraction({
      otherActions: `click-convert-email-to-drag-and-drop`
    });
    const newEmailName = `${email.name} ${suffix}`;
    const cloneOptions = Object.assign({
      variantOnly: false,
      name: newEmailName,
      folderId: email.folderId,
      cloneWithSmartContent: false,
      cloneWithCustomPlaintext: false,
      convertToDd: true,
      cloneWithNewBusinessUnitId: null,
      retainPermissionsAfterClone: false
    }, getExtraCloneOptions(email, hasAutomatedAccess));
    return confirmClone(email.id, cloneOptions);
  };
  const formatClonedEmailName = emailName => {
    const newName = `${emailName} ${suffix}`;
    if (newName.length > CONTENT_NAME_MAX_LENGTH) {
      const overMaxBy = newName.length - CONTENT_NAME_MAX_LENGTH;
      const truncatedEmailName = emailName.slice(0, emailName.length - overMaxBy - 3);
      return `${truncatedEmailName}... ${suffix}`;
    }
    return newName;
  };
  const handleCloneWithTypeAction = (templateMode, userSelections) => {
    const cloneOptions = {
      variantOnly: !!userSelections.variantOnly,
      name: userSelections.cloneEmailName || formatClonedEmailName(email.name),
      folderId: email.folderId,
      cloneWithSmartContent: userSelections.cloneWithSmartContent,
      cloneWithCustomPlaintext: userSelections.cloneWithCustomPlaintext,
      convertToDd: templateMode === EMAIL_TEMPLATE_MODE.DRAG_AND_DROP && email.emailTemplateMode !== EMAIL_TEMPLATE_MODE.DRAG_AND_DROP,
      cloneWithNewBusinessUnitId: userSelections.businessUnitId,
      retainPermissionsAfterClone: userSelections.retainPermissionsAfterClone
    };
    if (shouldCloneCustomProperties && assignedCustomProperties.length > 0) {
      cloneOptions.customProperties = assignedCustomProperties;
    }
    if (userSelections.emailType) {
      if (userSelections.emailType === EMAIL_CREATION_TYPES.AUTOMATED) {
        cloneOptions.state = 'AUTOMATED_DRAFT';
        cloneOptions.subcategory = 'automated';
      } else {
        cloneOptions.state = 'DRAFT';
        if (email.emailType === EMAIL_TYPE.LOCALTIME_EMAIL) {
          cloneOptions.subcategory = 'localtime';
        } else {
          cloneOptions.subcategory = 'batch';
        }
      }
    }
    if (getIsAutomatedLike(userSelections) && !getIsFollowupEmail(userSelections) &&
    // this condition avoid force conversion of follow up email to batch email.
    !hasAutomatedAccess) {
      cloneOptions.state = 'DRAFT';
      cloneOptions.subcategory = 'batch';
    }
    if (cloneOptions.cloneWithSmartContent === false) {
      trackDashboardInteraction({
        otherActions: `cloned-without-smart-content`
      });
    } else if (cloneOptions.convertToDd) {
      trackDashboardInteraction({
        otherActions: `click-convert-email-to-drag-and-drop`
      });
    } else {
      trackDashboardInteraction({
        otherActions: `click-email-template-mode-modal-clone-${templateMode.toLowerCase()}`
      });
    }
    if (!cloneOptions.retainPermissionsAfterClone) {
      trackDashboardInteraction({
        otherActions: 'cloned-without-permissions'
      });
    }

    // COSEMAIL-24477 - Pass the right variant contentId
    const contentId = userSelections && userSelections.contentId || email.id;
    return confirmClone(contentId, cloneOptions);
  };
  const renderConvertModal = () => {
    return /*#__PURE__*/_jsx(ConvertToCloneModal, {
      onClickConvert: handleConvertAction,
      onClose: onClose
    });
  };
  const renderCloneSidepanel = () => {
    return /*#__PURE__*/_jsx(EmailCloneSidePanel, {
      email: email,
      emailDetails: emailDetails,
      isConvertible: isConvertible,
      onClose: onClose,
      smartContentLocations: smartContentLocations,
      hasCustomPlaintext: hasCustomPlaintext,
      canAccessBusinessUnit: canAccessBusinessUnit,
      onClone: handleCloneWithTypeAction,
      variantSmartContentLocations: variantSmartContentLocations,
      variantHasCustomPlaintext: variantHasCustomPlaintext,
      assignedCustomProperties: assignedCustomProperties
    });
  };
  if (!isCloneDataReady && !isCloneDataErrored || isLoadingCRMObject || isLoadingAssignedCustomProperties) {
    return /*#__PURE__*/_jsx(UILoadingOverlay, {});
  }
  if (isConvertible && !userCanCreateClassicEmail) {
    return renderConvertModal();
  }
  if (userCanCreateClassicEmail || email.emailTemplateMode === EMAIL_TEMPLATE_MODE.DRAG_AND_DROP) {
    return renderCloneSidepanel();
  }
  return /*#__PURE__*/_jsx(CloneOrConvertNotAllowedModal, {
    action: "clone",
    onClose: onClose
  });
}
export default CloneOrConvertModal;